export default __webpack_public_path__ + "static/media/05SongForDon60s.8e3d238f.mp3";